import { module as BaseModule } from 'modujs'
import { load } from 'recaptcha-v3'

export default class extends BaseModule {
  init() {
    this.notice = this.el.querySelector('.notice')
    this.inputs = this.el.querySelector('.inputs')
    this.confirmation = this.el.querySelector('.confirmation')
    this.button = this.el.querySelector('button')
    this.isSending = false
    this.isSent = false

    this.el.addEventListener('submit', async (e) => {
      e.preventDefault()
      if (this.isSending || this.isSent) return
      this.verify()
    })
  }

  async verify() {
    this.isSending = false

    const recaptcha = await load('6Lfv71opAAAAAL12H61l7oL77zTGycZ5dP0_uQDg')
    const token = await recaptcha.execute('contactForm')

    try {
      const request = await fetch('/wp-json/custom/v1/recaptcha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
        }),
      })

      const response = await request.json()
      if (response.success === true && request.status === 200) {
        this.send()
        return
      }

      const { message } = response
      this.notice.classList.remove('hidden')
      this.notice.innerHTML = message
      this.button.innerHTML = 'Error!'
      this.isSending = false
    } catch (error) {
      console.error(error)
    }
  }

  async send() {
    this.isSending = true
    const formData = new FormData(this.el)

    const data = {}
    const formDataArray = Array.from(formData)
    formDataArray.forEach(([key, value]) => {
      data[key] = value
    })

    this.button.innerHTML = 'Submitting..'

    const request = await fetch('/wp-json/custom/v1/contact-form', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    const response = await request.json()
    const { status } = request
    const { message } = response

    if (status === 200) {
      this.button.classList.add('done')
      this.confirmation.classList.remove('hidden')
      this.inputs.classList.add('hidden')
      this.button.innerHTML = 'Submitted!'
      this.isSent = true
    } else {
      this.notice.classList.remove('hidden')
      this.notice.innerHTML = message
      this.button.innerHTML = 'Submit'
      this.isSending = false
    }
  }
}
